var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ranking",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "ranking-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "ranking-hero"
  }, [_c('div', {
    staticClass: "ranking-kicker"
  }, [_c('span'), _vm._v(_vm._s(_vm.$lang("Monpop leaderboard")))]), _c('div', {
    staticClass: "ranking-title"
  }, [_vm._v(_vm._s(_vm.$lang("Top tokens. Real momentum.")))]), _c('div', {
    staticClass: "ranking-sub"
  }, [_vm._v(_vm._s(_vm.$lang("Live market rankings across Monpop.fun")) + " · " + _vm._s(_vm.updatedAt) + " UTC")])]), _c('div', {
    staticClass: "ranking-msc"
  }, [_c('div', {
    staticClass: "ranking-con market"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_c('span', {
    staticClass: "ranking-con-icon"
  }, [_vm._v("M")]), _c('div', [_vm._v(_vm._s(_vm.$lang("Market Cap Ranking"))), _c('small', [_vm._v(_vm._s(_vm.$lang("Largest communities by value")))])])]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.mcapRankLoading ? _vm._l(_vm.mcapRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))])]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con volume"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_c('span', {
    staticClass: "ranking-con-icon"
  }, [_vm._v("V")]), _c('div', [_vm._v(_vm._s(_vm.$lang("24H Trading Volume"))), _c('small', [_vm._v(_vm._s(_vm.$lang("Most actively traded tokens")))])])]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Trading Volume")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.volumeRankLoading ? _vm._l(_vm.volumeRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', {
      staticClass: "g",
      domProps: {
        "innerHTML": _vm._s(`$ ${item.tradingVolume}`)
      }
    })]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con gainers"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_c('span', {
    staticClass: "ranking-con-icon"
  }, [_vm._v("↗")]), _c('div', [_vm._v(_vm._s(_vm.$lang("Top Gainers"))), _c('small', [_vm._v(_vm._s(_vm.$lang("Strongest 24-hour performance")))])])]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Price Gain 24h")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.diffRankLoading ? _vm._l(_vm.diffRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', {
      staticClass: "g",
      domProps: {
        "innerHTML": _vm._s(`${item.priceGain24h}%`)
      }
    })]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con migrated"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_c('span', {
    staticClass: "ranking-con-icon"
  }, [_vm._v("P")]), _c('div', [_vm._v(_vm._s(_vm.$lang("Almost Migrated"))), _c('small', [_vm._v(_vm._s(_vm.$lang("Closest to popping into the DEX")))])])]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Curve progress")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.almostRankLoading ? [_vm.almostRank && _vm.almostRank.length > 0 ? _vm._l(_vm.almostRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#9a88ff' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', [_c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress__label"
    }, [_c('i', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(item.sold_token, 6))
      }
    }), _vm._v("%")]), _c('div', {
      staticClass: "progress-main"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        width: (item.pool_ether !== '0' ? item.sold_token : 100) + '%'
      }
    })])])])]);
  }) : [_c('m-empty')]] : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };